import { getSearchParams } from 'functions/getSearchParams';
import { questionnaireApi } from 'modules/questionnaire/api';
import { BUNDLED_DISEASE_OPTIONS, GENERAL_DISEASE } from 'utils/constants/disease';

export const adjustTranslationKey = (key) => {
  if (!key) {
    return key;
  }
  return key.replace('questionnaire.', 'q_hcp.');
};

const formIndicationOptionValue = ({
  condition, subType, otherQuestionId, otherQuestion,
}) => (
  [condition, subType || null, otherQuestionId || null, otherQuestion || null].join('#')
);

export const formIndicationMainOptionValue = ({ condition, conditionSubType }) => formIndicationOptionValue({
  condition,
  subType: condition === GENERAL_DISEASE ? conditionSubType : null,
});

export const formIndicationOption = ({
  condition, subType, otherQuestionId, otherQuestion, label,
}) => ({
  value: formIndicationOptionValue({
    condition, subType, otherQuestionId, otherQuestion,
  }),
  label,
  condition,
  subType: subType || null,
  otherQuestionId: otherQuestionId || null,
  otherQuestion: otherQuestion || null,
});

export const fetchIndicationMainOptions = async () => {
  try {
    const serverDiseases = await questionnaireApi.getDiseasesList();

    return [
      ...BUNDLED_DISEASE_OPTIONS.map(({ value: condition, label }) => ({
        ...formIndicationOption({ condition, label }), isTranslationNeeded: true,
      })),
      ...serverDiseases.filter(({ value }) => value !== GENERAL_DISEASE)
        .map(({ label, name: condition }) => formIndicationOption({ condition, label })),
    ];
  } catch {
    return null;
  }
};

export const fetchIndicationSearchOptions = async () => {
  try {
    const { indicationLabelsData } = await getSearchParams();
    return indicationLabelsData.map(({
      label, value: condition, autoSelectType: subType, subType: otherQuestionId, autoSelectSubType: otherQuestion,
    }) => formIndicationOption({
      condition, subType, otherQuestionId, otherQuestion, label,
    }));
  } catch {
    return null;
  }
};
